var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto my-12",attrs:{"max-width":"374"}},[_c('v-card-title',[_c('v-icon',{attrs:{"x-large":"","color":"black"}},[_vm._v("mdi-emoticon-sad-outline")]),_c('h3',[_vm._v(_vm._s(_vm.$t("PAGE NOT FOUND")))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }